import Wprr from "wprr";
import React from "react";

import WprrBaseObject from "wprr/WprrBaseObject";

export default class Address extends WprrBaseObject {
	
	_construct() {
		super._construct();
		
		this._uiState = Wprr.sourceValue("normal");
	}
	
	_renderMainElement() {
		
		return React.createElement(Wprr.SelectSection, {selectedSections: this._uiState},
			React.createElement("div", {"data-section-name": "view", "data-default-section": true, },
				React.createElement(Wprr.CommandButton, {commands: Wprr.commands.setProperty(this._uiState.reSource(), "value", "edit")},
					React.createElement("div", {className: "standard-field standard-field-padding full-width"},
						React.createElement("div", {},
							Wprr.text(Wprr.sourceReference("field/externalStorage", "value.address1"))
						),
						React.createElement("div", {},
							Wprr.text(Wprr.sourceReference("field/externalStorage", "value.address2"))
						),
						React.createElement("div", {},
							Wprr.text(Wprr.sourceReference("field/externalStorage", "value.postCode")),
							" ",
							Wprr.text(Wprr.sourceReference("field/externalStorage", "value.city"))
						)
					)
				)
			),
			React.createElement("div", {"data-section-name": "edit"},
				React.createElement("div", {},
					React.createElement(Wprr.EditableProps, {editableProps: "value.address1", externalStorage: Wprr.sourceReference("field/externalStorage")},
						React.createElement(Wprr.FormField, {valueName: "value.address1", className: "standard-field standard-field-padding full-width"})
					)
				),
				React.createElement("div", {},
					React.createElement(Wprr.EditableProps, {editableProps: "value.address2", externalStorage: Wprr.sourceReference("field/externalStorage")},
						React.createElement(Wprr.FormField, {valueName: "value.address2", className: "standard-field standard-field-padding full-width"})
					)
				),
				React.createElement(Wprr.FlexRow, {classAddress: "halfs small-item-spacing"},
					React.createElement(Wprr.EditableProps, {editableProps: "value.postCode", externalStorage: Wprr.sourceReference("field/externalStorage")},
						React.createElement(Wprr.FormField, {valueName: "value.postCode", className: "standard-field standard-field-padding full-width"})
					),
					React.createElement(Wprr.EditableProps, {editableProps: "value.city", externalStorage: Wprr.sourceReference("field/externalStorage")},
						React.createElement(Wprr.FormField, {valueName: "value.city", className: "standard-field standard-field-padding full-width"})
					)
				)
			)
		);
	}
}